module.exports = __webpack_public_path__ + "static/media/status-danger.cb5e32ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/status-danger.svg
// module id = 160
// module chunks = 0